import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

import moment from 'moment';
declare var require: any;

@Component({
  selector: 'app-worker-daily-group-count',
  templateUrl: './worker-daily-group-count.component.html',
  styleUrls: ['./worker-daily-group-count.component.scss']
})
export class WorkerDailyGroupCountComponent implements OnInit {

  groups:any;

  filter: any;
  selected: any;

  u = Utils;

  constructor(private router: Router,private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() }
    this.getGroups();

  }

  getGroups(){

    this.filter = [];

    this.filter['start'] = this.selected.startDate.format("YYYY-MM-DD");
    this.filter['end'] = this.selected.endDate.format("YYYY-MM-DD");

    this.okService.get('reports/workerdailygroupcount', {start:this.filter['start'],end:this.filter['end']})
    .subscribe((data) => {
      //console.log('data',data);
      this.groups = data.body;

      //console.log('groups',this.groups);


    });
  }

  updateFilter(){
    this.getGroups();
  }

  clearFilter(){
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };
    this.updateFilter();
  }

  export(){

    let fields:any = {'export':true};
    fields['start'] = this.selected.startDate.format("YYYY-MM-DD");
    fields['end'] = this.selected.endDate.format("YYYY-MM-DD");

    this.okService.download("reports/workerdailygroupcount",fields);

  }

}
